import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule, CdkDragDrop } from '@angular/cdk/drag-drop';
import { BaseChartDirective } from 'ng2-charts';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

@Component({
  selector: 'app-dashboard-charts',
  standalone: true,
  imports: [CommonModule, DragDropModule, BaseChartDirective],
  template: `
    <div cdkDropList (cdkDropListDropped)="onDrop($event)"
         class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-8">
      
      <!-- Dynamic Widgets -->
      <div *ngFor="let w of widgets" cdkDrag
           class="bg-zaxis-card border border-zaxis-border p-5 relative group rounded-none"
           [ngClass]="{'lg:col-span-2': w.colSpan === 2}">
        
        <div class="flex justify-between items-center mb-4 border-b border-zaxis-border pb-3">
           <h3 class="text-[10px] font-mono font-bold text-gray-400 uppercase tracking-widest">{{ w.title }}</h3>
           <i cdkDragHandle class="ph ph-dots-six-vertical text-gray-600 cursor-grab opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:text-zaxis-accent"></i>
        </div>
        
        <div class="h-64 overflow-x-auto overflow-y-hidden custom-scrollbar">
          <div [style.min-width.px]="getChartWidthFn(w)" class="h-full relative w-full">
            <canvas baseChart
              [data]="getChartDataFn(w)"
              [options]="getChartOptionsFn(w)"
              [type]="w.type">
            </canvas>
          </div>
        </div>
        
        <!-- Drag Preview (Placeholder) -->
        <div *cdkDragPlaceholder class="bg-zaxis-dark border border-dashed border-zaxis-border rounded-none h-[330px]"></div>
      </div>
    </div>
  `
})
export class DashboardChartsComponent {
  @Input() widgets: any[] = [];
  @Input() getChartDataFn!: (key: string) => any;
  @Input() getChartOptionsFn!: (key: string) => any;
  @Input() getChartWidthFn!: (key: string) => number;

  @Output() widgetDropped = new EventEmitter<CdkDragDrop<string[]>>();

  onDrop(event: CdkDragDrop<string[]>) {
    this.widgetDropped.emit(event);
  }
}
